import '../styles/globals.css';
import React, {useEffect} from 'react';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import Script from 'next/script';
import * as Sentry from '@sentry/nextjs';
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import LANGUAGES from '../data/languages.json';
import { resolveCountry, resolveLanguage } from '../frontend';

declare global {
  interface Window {
    Sentry: any;
  }
}

class InternalizationApp extends React.Component {
  constructor(props: AppProps) {
    super(props);
    const locale: string | string[] | undefined = props.router?.query?.locale;
    const lng = resolveLanguage(locale);
    (async () => await i18n.use(initReactI18next).init({...LANGUAGES, lng}))();
  }
  render() {
    return <MyApp {...(this.props as AppProps)} />;
  }
}

function MyApp({ Component, pageProps, router }: AppProps) {
  const country: string | undefined = resolveCountry(router?.query?.locale);
  useEffect(() => { window.Sentry = Sentry; }, []);
  const { t } = useTranslation();
  return (
      <>
        <Head>
          <title>
            {country ?? t('Search')}
          </title>
          <script
            dangerouslySetInnerHTML={{
              __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-WWBBSM6');`,
            }}
          />
  
          <script defer async src='https://analytics.growthhub.com/analytics.js' />
        </Head>
        <Script
        type='text/javascript'
        src={`https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`}
        strategy='afterInteractive'
      />
        <Component {...pageProps} />
      </>
  )
}

export default InternalizationApp
